import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNote = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 25,
	height: 24,
	viewBox: "0 0 25 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		opacity: .5,
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M16.5 15H8.5",
				stroke: "black",
				strokeWidth: 1.5,
				strokeLinecap: "square",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.5 11H8.5",
				stroke: "black",
				strokeWidth: 1.5,
				strokeLinecap: "square",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9 5L9 2",
				stroke: "black",
				strokeWidth: 1.5,
				strokeLinecap: "square",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13 5L13 2",
				stroke: "black",
				strokeWidth: 1.5,
				strokeLinecap: "square",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M17 5L17 2",
				stroke: "black",
				strokeWidth: 1.5,
				strokeLinecap: "square",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 4.5,
				y: 3,
				width: 16,
				height: 18,
				rx: 4,
				stroke: "black",
				strokeWidth: 1.5
			})
		]
	})
});
export default SvgNote;
